export default __webpack_public_path__ + "./image/3dd15ff07da7836da9acf5291b9e8926.png";